import { css } from '@eti/styles';
import { Icon } from '@eti/components';
import { vars } from '@etg/wings';
import { rowIconWrapperStyles } from './styles';
import SummaryActionsCell from './SummaryActionsCell';
import SummaryPriceRow from './SummaryPriceRow';
import SummarySelectedSeatCell from './SummarySelectedSeatCell';
import SummaryTravelerCell from './SummaryTravelerCell';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const rowStyles = css`
  font-size: 0.875rem;
  position: relative;
  width: 100%;

  @media (max-width: 47.9375em) {
    border-top: 1px solid ${vars.colors.inputs.border};
    display: flex;
    flex-direction: column;
    padding: 0.5rem 0;
  }

  & > * {
    vertical-align: middle;

    @media (min-width: 48em) {
      border-top: 1px solid ${vars.colors.inputs.border};
    }
  }
`;
const iconCellStyles = css`
  ${rowIconWrapperStyles};

  @media (max-width: 47.9375em) {
    left: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    html[dir='rtl'] & {
      left: auto;
      right: 0;
    }
  }
`;
const travelerIconStyles = css`
  fill: ${vars.colors.decoration.neutral};
  height: 0.8rem;
  width: 0.8rem;

  @media (min-width: 48em) {
    height: 1.2rem;
    width: 1.2rem;
  }
`;
const SummaryTravelerRow = ({
  ageType,
  boundIndex,
  carrier,
  isRyanairInTrip,
  name,
  onRemoveSeat,
  onToggleSeatSelect,
  segmentIndex,
  selectedSeat,
  travelerIndex
}) => {
  return /*#__PURE__*/_jsxs("tr", {
    className: rowStyles,
    "data-testid": `seatMapSummaryTravelerRow-${travelerIndex}`,
    children: [/*#__PURE__*/_jsx("td", {
      className: iconCellStyles,
      children: /*#__PURE__*/_jsx(Icon, {
        className: travelerIconStyles,
        id: "adult-traveler"
      })
    }), /*#__PURE__*/_jsx(SummaryTravelerCell, {
      ageType: ageType,
      name: name
    }), /*#__PURE__*/_jsx(SummarySelectedSeatCell, {
      selectedSeat: selectedSeat && selectedSeat.value
    }), isRyanairInTrip ? /*#__PURE__*/_jsx(SummaryPriceRow, {
      carrier: carrier,
      markup: selectedSeat === null || selectedSeat === void 0 ? void 0 : selectedSeat.markup,
      seatPrice: selectedSeat === null || selectedSeat === void 0 ? void 0 : selectedSeat.price
    }) : /*#__PURE__*/_jsx(SummaryPriceRow, {
      markup: selectedSeat === null || selectedSeat === void 0 ? void 0 : selectedSeat.markup,
      seatPrice: selectedSeat === null || selectedSeat === void 0 ? void 0 : selectedSeat.price,
      tooltipId: `row_${boundIndex}_${segmentIndex}_${travelerIndex}`
    }), /*#__PURE__*/_jsx(SummaryActionsCell, {
      boundIndex: boundIndex,
      onRemoveSeat: onRemoveSeat,
      onToggleSeatSelect: onToggleSeatSelect,
      segmentIndex: segmentIndex,
      selectedSeat: selectedSeat,
      travelerIndex: travelerIndex
    })]
  });
};
export default SummaryTravelerRow;
//# sourceMappingURL=SummaryTravelerRow.js.map